import { emitter } from 'shared/helpers/mitt';
import { CHATWOOT_RESET } from 'dashboard/constants/appEvents';
import { invalidateProfileReads } from './profileReads';

export const installAccessLifecycle = store => {
  let user = store.state.auth.currentUser.id;
  let account = store.state.route?.params.accountId;
  const clearSession = () => {
    invalidateProfileReads();
    store.dispatch('permissionSets/clearAccess', { session: true });
  };
  const unsubscribe = store.subscribe((_mutation, state) => {
    const nextUser = state.auth.currentUser.id;
    const nextAccount = state.route?.params.accountId;
    if (user === nextUser && account === nextAccount) return;
    user = nextUser;
    account = nextAccount;
    clearSession();
  });
  emitter.on(CHATWOOT_RESET, clearSession);
  return () => {
    unsubscribe();
    emitter.off(CHATWOOT_RESET, clearSession);
  };
};
